import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import {
  SubtitleNewCardMedias,
  TextCircle,
} from '../../styles/typographyNewCardMedias';

import { Container, CardInfo } from './styles';

interface ICard {
  description: string;
  path?: string;
  title: string;
  value?: string;
  name?: string;
}

const NewCardMedias = ({ description, path, value, title, name }: ICard) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const width = window.innerWidth;

  const handleNextStep = () => {
    value &&
      name &&
      dispatch({ type: 'ADD_DEV_BUDGET', payload: { [name]: value } });
    if (path) {
      const currentParams = location.search;
      const hasAppParam = currentParams.includes('app');

      if (hasAppParam && !path.includes('?')) {
        history.push(`/ti/${path}?app`);
      } else {
        history.push(`/ti/${path}`);
      }
    }
  };
  return (
    <Container onClick={handleNextStep}>
      <CardInfo>
        <SubtitleNewCardMedias onClick={handleNextStep}>
          {title}
        </SubtitleNewCardMedias>
        <TextCircle onClick={handleNextStep}>{description}</TextCircle>
      </CardInfo>
    </Container>
  );
};

export default NewCardMedias;
